import { useTransferType } from '../use-transfer-type';
import { RhNumberField } from '../../../../../../dum';
import React from 'react';
import { CURRENCY_INPUT_PROPS } from '../currency-input-props';
import { FIELD_LABELS, shortLabel } from '../../../../../../../helpers';

export function AmountInput() {
    const transferType = useTransferType();

    return (
        <RhNumberField
            disabled={
                transferType.is_client_transfer ||
                transferType.is_supplier_transfer
            }
            name={'amount'}
            label={shortLabel(FIELD_LABELS.amount)}
            InputProps={CURRENCY_INPUT_PROPS}
        />
    );
}
